export function removeTireRackOrderFromOrder(
  orderObjectId: string | undefined,
  tireRackOrderNumber: string,
) {
  return {
    method: 'DELETE',
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderObjectId}/tire-rack-order/${tireRackOrderNumber}`,
  }
}
